import React, { ChangeEvent, ReactElement } from 'react';
import styled from 'styled-components';
import { Controller, useFormContext, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckBox from 'components/theme/CheckBox/CheckBox';
import { ErrorContainer, Error } from 'components/theme/Form';

interface ITextFieldProps {
  name: string;
  label?: string | ReactElement;
  id?: string;
  required?: boolean;
  defaultValue?: boolean;
  rules?: RegisterOptions;
}

const CheckboxField = ({
  name,
  label,
  id,
  required,
  rules,
  ...props
}: ITextFieldProps) => {
  const { control } = useFormContext();
  const { t: translate } = useTranslation();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={props.defaultValue || false}
      render={({ field, fieldState }) => {
        const errorMessage = fieldState.error?.message as string;
        return (
          <LabelSpacing>
            <CheckBox
              id={id}
              label={label}
              required={required ?? false}
              {...field}
              checked={field.value}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                field.onChange(e.target.checked)
              }
              aria-invalid={!!errorMessage}
            />
            {errorMessage && (
              <ErrorContainer>
                <Error>{translate(errorMessage)}</Error>
              </ErrorContainer>
            )}
          </LabelSpacing>
        );
      }}
      {...props}
    />
  );
};

const LabelSpacing = styled.div`
  display: block;
`;

export default CheckboxField;
